module.exports = __webpack_public_path__ + "img/vuma-fibre-process-5.1aa5b096.svg";